import React, { useState } from "react";
import * as Yup from "yup";

import Form from "@Components/Form";
import {
  ESTATE_FETCH_URL,
  REGION_FETCH_URL,
  URLS,
  ZONE_FETCH_URL,
  WORKER_FETCH_URL,
  REMARKS_URL,
} from "configs/constants";
import { COMPANY_FETCH_URL } from "configs/constants";

let API_URL = "attendance/add/";
const status = [
  {
    id: "Absent",
    name: "Absent",
  },
  {
    id: "Present",
    name: "Present",
  },
];

const initialValues = {
  employee_id: "",
  date: null,
  clock_out_time: null,
  clock_in_time: null,
  company: "",
  zone: "",
  region: "",
  estate: "",
  status: "",
  remarks_id: "",
  remarks_reason: "",
};

const validationSchema = Yup.object({
  company: Yup.string().required("Company is required").typeError("Company is required"),
  zone: Yup.string().required("Zone is required").typeError("Zone is required"),
  region: Yup.string()
    .required("Region is required")
    .typeError("Region is required"),
  estate: Yup.string()
    .required("Estate is required")
    .typeError("Estate is required"),
  employee_id: Yup.string()
    .required("Worker id is required")
    .typeError("Invalid employee name"),
  remarks_id: Yup.string()
    .required("Type of Attendance is required")
    .typeError("Type of Attendance is required"),
  status: Yup.string()
    .required("Status is required")
    .typeError("Status is required"),
  date: Yup.string().required("Date is required").typeError("Date is required"),
});

const getCompanyValues = (e, setDisableZone) => {
  if (!e || e.length === 0) {
    setDisableZone(true);
  }
  else {
    setDisableZone(false);
  }

};

const getZoneValues = (e,setDisableRegion) => {
  if (!e || e.length === 0) {
    setDisableRegion(true);
  }
  else {
    setDisableRegion(false);
  }
  
};
const getRegionValues = (e,setDisableEstate) => {
  if (!e || e.length === 0) {
    setDisableEstate(true);
  }
  else {
    setDisableEstate(false);
  }
  
};
const AttendanceAddForm = () => {
  const [disableRegion, setDisableRegion] = useState(true);
  const [disableEstate, setDisableEstate] = useState(true);
  const [disableZone, setDisableZone] = useState(true);

  const formFields = [
    { type: "title", title: "Worker Details" },
    {
      type: "reactselect",
      name: "company",
      label: "Company",
      proxyUrl: COMPANY_FETCH_URL,
      getValue: (e) => getCompanyValues(e, setDisableZone),
      paginated: true,
      required: true,


    },
    {
      type: "reactselect",
      name: "zone",
      label: "Zone",
      proxyUrl: ZONE_FETCH_URL,
      required:true,
      getValue: (e) => getZoneValues(e, setDisableRegion),
      paginated: true,
      disabled:disableZone,
      optionsDependsOn: "company",
    },
    {
      type: "reactselect",
      name: "region",
      label: "Region",
      proxyUrl: REGION_FETCH_URL,
      paginated: true,
      required:true,
      disabled:disableRegion,
      getValue: (e) => getRegionValues(e, setDisableEstate),
      optionsDependsOn: "zone",
    },
    {
      type: "reactselect",
      name: "estate",
      label: "Estate",
      proxyUrl:   ESTATE_FETCH_URL,
      disabled:disableEstate,

      paginated: true,
      optionsDependsOn: "region",
    },
    {
      type: "reactselect",
      name: "employee_id",
      label: "Worker Name",
      proxyUrl: WORKER_FETCH_URL,
      paginated: true,
      required: true,
      optionsDependsOn: "estate",
    },
    { type: "title", title: "Attendance Details" },
    {
      type: "datepicker",
      label: "Date",
      name: "date",
      required: true,
    },
    {
      name: "status",
      label: "Status",
      type: "reactselect",
      outerOptions: status,
      required: true,
    },
    {
      name: "remarks_id",
      label: "Type of Attendance",
      type: "reactselect",
      required: true,
      proxyUrl: REMARKS_URL,
      paginated: true,
      optionsDependsOn: "status",
    },
    {
      name: "remarks_reason",
      label: "Others-Please Specify",
      type: "input",
      renderKey: "remarks_id",
      renderValue: 20000,
      required: true,
    },
    {
      type: "timepicker",
      name: "clock_in_time",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Mobile Clock In",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      emptyLabel: "",
    },
    {
      type: "timepicker",
      name: "clock_out_time",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Mobile Clock Out",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 4 },
      emptyLabel: "",
    },
  ];

  const formButtons = ["submit", "cancel"];

  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      submitUrl={API_URL}
      listRoute={URLS.ATTENDANCE_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Attendance Record"
    />
  );
};

export default AttendanceAddForm;
